/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Holidays_Frost_FreeInputs */



/**
* | output |
* | --- |
* | "Holidays/Frost Free" |
*
* @param {Holidays_Frost_FreeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const holidays_frost_free = /** @type {((inputs?: Holidays_Frost_FreeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Holidays_Frost_FreeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Holidays/Frost Free")
	return /** @type {LocalizedString} */ ("Vacances/Hors Gel")
});